"use client";

import { useState } from "react";
import LoadingButton from "@mui/lab/LoadingButton";
import { Box } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

const BASE_URL = process.env.NEXT_PUBLIC_BASE_URL;

export default function DeleteToFavourite({ product, refresh, removeProductFavorites }) {
  const { id } = product;
  const [isLoading, setLoading] = useState(false);


  const handleRemove = async () => {
    try {
      setLoading(true);
      await removeProductFavorites(id);
      refresh();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box display="flex">
      <LoadingButton
        color="primary"
        variant="contained"
        loading={isLoading}
        onClick={handleRemove}
        sx={{
          mb: 4.5,
          background: "rgb(23, 19, 85)",
          height: 30,
          width: 20,
          float: "right",
        }}
      >
        <DeleteIcon />
      </LoadingButton>
    </Box>
  );
}
